// Relative URLs by default — the same build works on any host. The browser
// prefixes them with whichever hostname it's on, so noc.onlinetn.com (staging)
// hits its own /api and eri.tn.gov.in (prod) hits eri.tn.gov.in/api.
// The web server on each host proxies /api/* to the local Node backend
// (port 3005) and serves /uploads/* from the backend's uploads folder.
//
// Only if a host can't proxy /api, build with an explicit address, e.g.
//   REACT_APP_API_BASE_URL=https://eri.tn.gov.in/api REACT_APP_FILE_BASE_URL=https://eri.tn.gov.in/uploads npm run build
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || "/uploads";

export { API_BASE_URL, FILE_BASE_URL };
